import { Price } from "flicket-ui";

export default function PriceOrFree({ price }: { price: number }) {
  if (price === 0) {
    return <>Free</>;
  }

  return <Price price={price} />;
}
